import type { RequestConfig, RequestOptions } from '@umijs/max';
import { errorConfig } from './requestErrorConfig';

export const request: RequestConfig = {
  ...errorConfig,
  requestInterceptors: [
            (config: RequestOptions) => {
              const token = localStorage.getItem('token');
              
              // Add token to headers
              if (token) {
                config.headers = {
                  ...(config.headers || {}),
                  Authorization: `Bearer ${token}`,
                };
              }
              
              return config;
            },
          ],
};
